import * as React from 'react';
import {CssBaseline, Box, Container, Typography, Tooltip, Button } from "@mui/material";
import {useEffect, useState, useCallback, useRef} from 'react';
import {useLocation, useNavigate, useParams} from 'react-router-dom';


import "./saladevideo.css";
// @mui
import {styled} from '@mui/material/styles';
import {useSettingsContext} from '../../../../components/settings';
// eslint-disable-next-line import/no-cycle


import CustomBreadcrumbs from '../../../../components/custom-breadcrumbs';
// routes
import {PATH_AUTH, PATH_DASHBOARD} from '../../../../routes/paths';
import axios from "../../../../utils/axios";
import {useAuthContext} from "../../../../auth/useAuthContext";
import Iconify from "../../../../components/iconify";
// eslint-disable-next-line import/no-cycle
import RodapeSaladeAudio from "./RodapeSaladeVideo";
import {CustomAvatar} from "../../../../components/custom-avatar";
import BadgeStatus, {BadgeStatusValue} from "../../../../components/badge-status";
import HeaderSaladeVideo from "./HeaderSaladeVideo";



// ----------------------------------------------------------------------

type props = {
    Backaudio: any,
    fecharvideo:any
};

export default function EncerraSalaVideo({Backaudio, fecharvideo}:props) {



    const {tokenConversa = ''} = useParams();
    const [usera,setuser] = useState<any>({});
    const [status, setStatus] = useState<BadgeStatusValue>('online');

    useEffect(  () => {
        const fetchRepos2 = async () => {
            const response = await axios.get(`/areadoatendente/atendente/${tokenConversa}`);

            const {atendente} = response.data;


            setuser(atendente)
        }
        fetchRepos2();

    },[tokenConversa]);

    const UrlVoltar = () =>{
        console.log('teste encerrar');
        Backaudio('Ativo');
    }
    const Encerrar = () =>{
        sessionStorage.setItem('paginaAnterior', 'encerrasalavideo');
        fecharvideo();
    }


    return (
        <>
            <HeaderSaladeVideo UrlVoltar={UrlVoltar}/>
            <CssBaseline/>
            <Container maxWidth="xl" className='GlobalChamadaEncerradaVideo'>
                <Box sx={{bgcolor: '#fff', height: '100vh', width: '100vw'}}>

                    
                    

                    <div className='containerInterno'>

                        <div className='InfosChamada'>                    
                            <Typography className='NomeUser'>{usera?.nome}</Typography>
                        </div>

                        <CustomAvatar
                            src={usera?.avatar}
                            alt={usera?.nome}
                            name={usera?.nome}
                            BadgeProps={{
                                badgeContent: <BadgeStatus status={status} />,
                            }}
                            sx={{ cursor: 'pointer', width: 120, height: 120 }}
                        />
                        
                        <div className='InfosChamadaEncerradaVideo'>                    
                            <Typography className='DesejaEncerrarChamadaVideo'>Deseja encerrar essa
                            chamada de Video?</Typography>
                            <div className='textoChamadaEncerradaVideo'>Caso encerre a chamada, você voltará para o chat por mensagem.</div>
                        </div>
                        

                        

                        <button type='button' onClick={Encerrar} className='EncerrarBotaoVideo'>
                            <Iconify icon="eva:phone-fill" sx={{mr: 1}}/>
                            <Typography>Encerrar</Typography>
                        </button>    

                            
                       
                    </div>
                </Box>
            </Container>

            </>
    );
}